import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import {AngularFireStorage} from '@angular/fire/storage';
import { AuthService } from '@auth0/auth0-angular';
import {forbiddenEmailValidator, addressValidator, priceValidator} from '../em.validator'
import { ApiService } from '../api.service';

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.sass']
})
export class EditorComponent implements OnInit {

  editorForm: FormGroup
  @Input() edittedPost: object;
  @Input() editVal: boolean;
  @Input() addVal: boolean;
  @Input() currentPostPage: number;
  @Input() totalPosts: number;

  gallery: any

  @ViewChild('replaceButton', {read: ElementRef}) replaceButton;

  @Output() reloadPostData = new EventEmitter()

  constructor(private sanitizer: DomSanitizer, private fireUpload:AngularFireStorage, public auth: AuthService, private apiService: ApiService, private renderer: Renderer2) { }
  imageLoad: any
  imageURL: string
  imgUploaded = []
  urlLoaded = []
  elle: any
  newImg: any
  detailText: any
  index: number = 0
  savedPost = {}
  profileJson = {}
  profVal: number = 0;
  submitted = ''
  replaceVal = false
  replaced = false
  ngOnInit() {
    
    this.editorForm = new FormGroup({
      'seller': new FormControl(this.edittedPost !== undefined ? this.edittedPost['seller_name'] : '', [Validators.required]),
      'email': new FormControl(this.edittedPost !== undefined ? this.edittedPost['email'] : '', [Validators.required, forbiddenEmailValidator]),
      'item': new FormControl(this.edittedPost !== undefined ? this.edittedPost['item'] : '', [Validators.required]),
      'category': new FormControl(this.edittedPost !== undefined ? this.edittedPost['category'] : '', [Validators.required]),
      'price': new FormControl(this.edittedPost !== undefined ? this.edittedPost['price'] : null, [Validators.required, priceValidator]),
      'address': new FormControl(this.edittedPost !== undefined ? this.edittedPost['address'] : null, [Validators.required, addressValidator]),
      'city': new FormControl(this.edittedPost !== undefined ? this.edittedPost['city'] : null, [Validators.required]),
      'state': new FormControl(this.edittedPost !== undefined ? this.edittedPost['state'] : null, [Validators.required]),
      'zipcode': new FormControl(this.edittedPost !== undefined ? this.edittedPost['zipcode'] : null, [Validators.required]),
      'short_details': new FormControl(this.edittedPost !== undefined ? this.edittedPost['short_details'] : null, [Validators.required]),
      'editor': new FormControl(this.edittedPost !== undefined ? this.sanitizer.sanitize(1, this.edittedPost['details']) : null),
      'images': new FormControl(null, this.replaceVal ? [Validators.required] : []),
      'tags': new FormControl(this.edittedPost !== undefined ? this.edittedPost['tags'] : null, [Validators.required]),
    });
    this.auth.user$.subscribe(
      profile => {
        this.profileJson = profile
        profile['name'].split("").map((char) => {
          this.profVal+=char.charCodeAt(0)
        }
        )
      }
    );
  }

  get titleGet() {
    return this.editorForm.get('title')
  }

  get priceGet() {
    return this.editorForm.get('price')
  }

  get addressGet() {
    return this.editorForm.get('address')
  }

  get categoryGet() {
    return this.editorForm.get('category').value
  }

  get editorGet() {
    return this.editorForm.get('editor')
  }

  get imagesGet() {
    if (this.editorForm.get('images').value) {
      return this.editorForm.get('images').value
    }
    else {
      return 0
    }
  }

  imgUpload(event) {
      this.gallery = event.target.files
      this.replaced = true
  }

  async newPost() {
    this.submitted = 'loading'
    if (this.replaceVal || this.addVal) {
      for (let i = 0; i<this.gallery.length; i++) {
        this.imageLoad = await this.fireUpload.upload(`excess/${this.profileJson["nickname"]}${this.profVal}${this.profileJson['sub'].substring(18)}/` + Math.random() + this.gallery[i].name.replace(/[!"#$%&'()*+,/:;<=>?@[\]^_`{|}~ ]/g, ''), this.gallery[i])
        this.imgUploaded.push(this.imageLoad)
      }
  
      for (let j = 0; j<this.imgUploaded.length; j++) {
        await this.imgUploaded[j].ref.getDownloadURL().then(url => {
        this.urlLoaded.push(url)
        })
      }

      this.savedPost['gallery'] = this.urlLoaded

    }

    this.savedPost['user_id'] = this.profileJson['sub'].substring(18)
    this.savedPost['seller_name'] = this.editorForm.get('seller').value
    this.savedPost['category'] = this.editorForm.get('category').value
    this.savedPost['item'] = this.editorForm.get('item').value
    this.savedPost['price'] = this.editorForm.get('price').value
    this.savedPost['address'] = this.editorForm.get('address').value
    this.savedPost['city'] = this.editorForm.get('city').value
    this.savedPost['state'] = this.editorForm.get('state').value
    this.savedPost['zipcode'] = this.editorForm.get('zipcode').value
    this.savedPost['email'] = this.editorForm.get('email').value
    this.savedPost['short_details'] = this.editorForm.get('short_details').value
    if (this.editorForm.get('editor').value !== null) {
      let replacedVal = this.editorForm.get('editor').value.replace(/[<]p[>][<]br[>][<][/]p[>]/g, '')
      this.savedPost['details'] = replacedVal
    }

    else {
      this.savedPost['details'] = ''
    }

    this.savedPost['sold_at'] = null
    this.savedPost['sold'] = false
    this.savedPost['tags'] = this.editorForm.get('tags').value

    if (this.addVal) {
      this.apiService.postPost(this.savedPost, this.profileJson['sub'].substring(18)).subscribe(data => {
        this.reloadPostData.emit("add")
        this.submitted = 'submitted'

      },
        (error)=> {console.log("add error", error)})
    }

    else if (this.editVal) {
      if (this.replaceVal) {
        for (let i in this.edittedPost['gallery']) {
          this.fireUpload.storage.refFromURL(this.edittedPost['gallery'][i]).delete()
        }
      }
      this.apiService.editPost(this.savedPost, this.edittedPost['id']).subscribe(data => {
        this.reloadPostData.emit("update")
        this.submitted = 'submitted'
      },
        (error)=> {console.log("error", error)})
    }
  }

  deleteImg(url) {
    return this.fireUpload.storage.refFromURL(url).delete();
  }

  switchImg(dir) {
    if (dir === "right") {
      if (this.index === this.urlLoaded.length - 1) {
        this.index = 0
      }
      else {
        this.index = this.index + 1
      }
    }
    else {
      if (this.index === 0) {
        this.index = this.urlLoaded.length - 1
      }
      else {
        this.index = this.index - 1
      }
    }

    this.newImg = document.getElementsByClassName("mainIMG")[0]
    this.newImg.setAttribute('src', this.urlLoaded[this.index])

  }

  replaceImages(val) {
      if (!val) {
        this.renderer.addClass(this.replaceButton.nativeElement,'replacedYes')
      }
      else {
        this.renderer.removeClass(this.replaceButton.nativeElement,'replacedYes')
      }

      this.replaceVal = !val

  }
}